<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 20 20"
    fill="none"
    style="enable-background:new 0 0 20 20;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g id="icon_shields">
        <path id="Path 14" d="M9.25 9.78729L18.007 18.3566"  stroke-linejoin="round"/>
        <path id="Path 15" d="M1.375 1.36328H12.625"  stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Path" d="M7 14.8047H4.9375C3.17709 14.8047 1.75 13.427 1.75 11.7275V3.17969H12.25V7.36217"  stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Path Copy 8" fill-rule="evenodd" clip-rule="evenodd" d="M19 16.0869C19 17.7864 17.6748 19.1641 16.0402 19.1641H12.2098C10.5752 19.1641 9.25 17.7864 9.25 16.0869C9.25 16.0869 9.25 14.2033 9.25 13.2615C9.25 11.354 9.25 7.53906 9.25 7.53906H14.0959H19V16.0869Z"  stroke-linejoin="round"/>
    </g>
  </svg>
</template>
<style scoped>
.icon-shields {
  stroke: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-shields"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>